import { ReportingSetFieldType } from "src/shared/models/reporting-set-data.model";
import { IconType } from "../report/channel-type-cell-renderer/channel-type-cell-renderer.model";

export interface DateObject {
    name: string;
    displayName: string;
}

export interface ReportColumnInfo {
    reportFieldKey: string;
    displayName: string;
    dataType: ReportingSetFieldType;
    cellRenderer?: string;
}

export const channelTypeToIconMap: { [key: string]: IconType } = {
    'CHAT': IconType.Chat,
    'PHONE_CALL': IconType.Voice,
    'EMAIL': IconType.Email,
    'SMS': IconType.SMS,
    'PHONE_CALL_IVR': IconType.IVR,
    'FB_PRIVATE': IconType.Facebook_Messenger,
    'TW_PRIVATE': IconType.Twitter_Direct_Message,
    'WHATSAPP_PRIVATE': IconType.WhatsApp,
    'APPLE_BUSINESS_CHAT_PRIVATE': IconType.Apple_Business_Chat,
    'LINE_PRIVATE': IconType.LINE_Messaging,
    'TELEGRAM_PRIVATE': IconType.Telegram_Messenger,
    'VIBER_PRIVATE': IconType.Viber_Messenger,
    'CUSTOM_PRIVATE': IconType.Custom,
    'WORKITEM': IconType.WorkItem,
    'GOOGLE_BUSINESS_MESSAGES_PRIVATE': IconType.Google_Business_Messenger,
    'SLACK_PRIVATE': IconType.Slack,
    'MICROSOFT_TEAMS_PRIVATE': IconType.Microsoft_Teams,
    'FB_PUBLIC': IconType.Facebook_Public,
    'TW_PUBLIC': IconType.Twitter_Public,
    'YT_PUBLIC': IconType.YouTube_Public,
    'LI_PUBLIC': IconType.LinkedIn_Public,
    'APPLE_APPS_REVIEWS_PUBLIC': IconType.Apple_Apps_Reviews_Public,
    'GOOGLE_PLACES_PUBLIC': IconType.Google_Places_Public,
    'GOOGLE_PLAY_PUBLIC': IconType.Google_Play_Public,
    'CUSTOM_PUBLIC': IconType.Custom_Public,
    'DESKTOP_ACTIVITY': IconType.Desktop_Activity
};